export default "__VITE_ASSET__78c1e423__"